// In-memory mock for @forge/api storage
// biome-ignore lint/suspicious/noExplicitAny: This is a mock
const _storage = new Map<string, any>()

export const storage = {
  async get(key: string) {
    return _storage.get(key)
  },
  // biome-ignore lint/suspicious/noExplicitAny: This is a mock
  async set(key: string, value: any) {
    _storage.set(key, value)
  },
  async delete(key: string) {
    _storage.delete(key)
  }
}

// Minimal mock for @forge/resolver
export class Resolver {
  // biome-ignore lint/complexity/noBannedTypes: This is a mock
  private handlers: Record<string, Function> = {}
  // biome-ignore lint/complexity/noBannedTypes: This is a mock
  define(key: string, fn: Function) {
    this.handlers[key] = fn
    return this
  }
  getDefinitions() {
    return this.handlers
  }
}

// Minimal mock for webTrigger
export const webTrigger = {
  async getUrl(_name: string, _forceNew?: boolean) {
    // Always return the Vite dev server mock webtrigger endpoint
    return 'http://localhost:3000/api/dev/test-webtrigger'
  },
  async deleteUrl(_url: string) {
    // No-op in mock
    return
  }
}
